<div class="mct-flex mct-col mct-gap-27"   *ngIf="socialMediaData">
  <div>
    <label>{{ socialMediaData.Label }}</label>
    <input type="text" class="form-control" />
  </div>
</div>
